import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SwitchIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 17 18">
      <path
        fill="currentColor"
        d="M15.416 7.906a.528.528 0 0 1 .95.376c-.523 4.264-4.035 7.52-8.28 7.772v.821c0 .776-.439 1.124-.874 1.124-.285 0-.569-.138-.843-.412l-2.99-2.99a1.686 1.686 0 0 1 0-2.38l2.99-2.988c.274-.274.558-.414.843-.414.435 0 .875.348.875 1.124v.906q.656.117 1.314.117a7.48 7.48 0 0 0 6.015-3.056M9.786 0c.286 0 .57.14.843.413l2.99 2.99a1.685 1.685 0 0 1 0 2.38l-2.99 2.988c-.274.274-.558.414-.843.414a.81.81 0 0 1-.704-.409c-.113-.187-.17-.43-.17-.716v-.905a7.5 7.5 0 0 0-1.315-.118 7.48 7.48 0 0 0-6.015 3.056.528.528 0 0 1-.95-.375c.523-4.264 4.036-7.521 8.28-7.772v-.822C8.912.348 9.351 0 9.786 0"
      />
    </BaseIcon>
  );
}
